import { createSlice } from '@reduxjs/toolkit';
import  { setAppLanguage } from '../../i18n';

const storedLang = localStorage.getItem('i18nextLng') || 'en';

const langSlice = createSlice({
  name: 'lang',
  initialState: { lang: storedLang },
  reducers: {
    setLang: (state, action) => {
      state.lang = action.payload;
      setAppLanguage(action.payload);
    },
  },
});

export const { setLang } = langSlice.actions;
export default langSlice.reducer; 